import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/service';
import { Configuration } from 'src/app/shared/model/configuration.model';
import { defaultFieldVisibility, FieldVisibility } from "../../shared";

@Component({
  selector: 'customer-data',
  templateUrl: './customer-data.component.html',
  styleUrls: ['./customer-data.component.scss']
})
export class CustomerDataComponent implements OnInit {

  @Input('translationNamespace') translationNamespace: string = 'CUSTOMER';

  @Input() fieldVisibility?: FieldVisibility;

  config$: Observable<Configuration>;

  constructor(
    public controlContainer: ControlContainer,
    private configService: ConfigService
  ) {
    this.config$ = this.configService.config$;
  }

  ngOnInit(): void {
    if (!this.fieldVisibility) {
      this.fieldVisibility = { ...defaultFieldVisibility };
    }
  }

  get namespacedCustomerNameField() : string {
    return 'FORM.ADDRESS_DATA.' + this.translationNamespace + '.NAME';
  }

  get namespacedCustomerPointCodeField() : string {
    return 'FORM.ADDRESS_DATA.' + this.translationNamespace + '.POINT_CODE';
  }

  getNamespacedCustomerFieldName(fieldName: string) : string {
    return this.translationNamespace.toLowerCase() + fieldName;
  }

  get customerFormControls() : any {
    let control = this.controlContainer.control as FormGroup;
    return control.controls;
  }
}
